import { DatepickerController, InputBase } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";
import { Objects } from "@salaxy/core";

/**
 * Modified ui.bootstrap.datepicker.
 * The component can be bound to a string typed variable.
 * @example
 * ```html
 * <salaxy-datepicker name="myDatepicker" ng-model="temp" label="Basic datepicker"></salaxy-datepicker>
 * ```
 */
export class Datepicker extends ComponentBase {

  /** ng-model is required, form tag is optionally used for validation and disabled/readonly */
  public require = {
    model: "ngModel",
    form: "?^^form",
  };

  /**
   * The following component properties (attributes in HTML) are bound to the Controller.
   * For detailed functionality, refer to [controller](#controller) implementation.
   */
  public bindings = Objects.extend(InputBase.crudBindings, {
    /**
     * Preset algorithms for enabled/disabled dates.
     * Currently, "salary" and "next-weekday" are implemented.
     * If set as "disable-function", you should set the disable-function too.
     */
    dateDisabled: "@",

    /** Disable function for date. If set, date-disabled is ignored. */
    disableFunction: "<",

    /** Payment channel. This affects which dates are disabled in the salary date selection. */
    paymentChannel: "<",

    /** Zero payment (no worker net salary payment). This affects which dates are disabled in the salary date selection. */
    zeroPayment: "<",

    /**
     * Minimum available date.
     * Bindable and ISO string version of the datepicker-options.minDate.
     * Currently not supported together with dateDisabled filters.
     */
    minDate: "<",

    /**
     * Maximum available date.
     * Bindable and ISO string version of the datepicker-options.maxDate.
     * Currently not supported together with dateDisabled filters.
     */
    maxDate: "<",

    /**
     * If true, can pick multiple dates from the selector.
     */
    isMultiple: "<",

    /**
     * Whether to show timepicker alongside the calendar.
     */
    timepicker: "<",

    /**
     * Whether to show Today/Clear buttons below the calendar.
     */
    showButtons: "<",

    /**
     * External value that causes the disabled dates function to re-run.
     */
    updateDisabledDates: "<",

    /** ng-change callback */
    ngChange: "&?",
  });

  /** Uses the DatepickerController */
  public controller = DatepickerController;

  /** The default template for the component. */
  public defaultTemplate = "salaxy-components/form-controls/Datepicker.html";
}
